import { render, staticRenderFns } from "./InsurancePolicyManagement.vue?vue&type=template&id=1db4b215&scoped=true&"
import script from "./InsurancePolicyManagement.vue?vue&type=script&lang=js&"
export * from "./InsurancePolicyManagement.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePolicyManagement.vue?vue&type=style&index=0&id=1db4b215&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4b215",
  null
  
)

export default component.exports